export function getter(key: string) {
  if (!window.localStorage) return;
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (err) {
    console.error('Error reading from localStorage');
  }
}

export function setter(key: string, data: any) {
  if (!window.localStorage) return;
  localStorage.setItem(key, JSON.stringify(data));
}